/* BarvoDeka theme – JS (bez knihoven) */
(function () {
  'use strict';

  var BD = window.BD || {};
  var routes = BD.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var nativeFetch = window.fetch.bind(window);

  /* ---------- Pomocné ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || BD.moneyFormat || '{{amount}} Kč';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#BdToast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3500);
  }

  function emojify(el) { if (window.BDEmojify) window.BDEmojify(el); }


  /* ---------- Zásuvky (menu, košík) ---------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var btn = $('[data-drawer-close].icon-btn', drawer);
    if (btn) setTimeout(function () { btn.focus(); }, 50);
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); return; }
    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && $('#CartDrawer')) { e.preventDefault(); openDrawer($('#CartDrawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = $('.drawer.is-open'); if (d) closeDrawer(d); }
  });

  /* ---------- Hlavička ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Oznámení ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var ms = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, ms);
  });

  /* ---------- Animace při scrollu ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Slider recenzí na mobilu (posun prstem, šipky, tečky) ---------- */
  function initSliders(root) { $$('[data-slider]', root).forEach(initSlider); }
  function initSlider(slider) {
    var wrap = slider.parentNode;
    var dots = wrap.querySelector('[data-slider-dots]');
    var prev = wrap.querySelector('[data-slider-prev]'), next = wrap.querySelector('[data-slider-next]');
    var items = slider.children;
    if (items.length < 2) return;
    var step = function () { var a = items[0].getBoundingClientRect(), b = items[1].getBoundingClientRect(); return (b.left - a.left) || a.width || 1; };
    var current = function () { return Math.max(0, Math.min(items.length - 1, Math.round(slider.scrollLeft / step()))); };
    var go = function (i) { i = Math.max(0, Math.min(items.length - 1, i)); slider.scrollTo({ left: i * step(), behavior: 'smooth' }); };
    if (dots) {
      for (var k = 0; k < items.length; k++) {
        (function (k) { var d = document.createElement('span'); d.addEventListener('click', function () { go(k); }); dots.appendChild(d); })(k);
      }
    }
    var update = function () {
      var idx = current();
      if (dots) $$('span', dots).forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === items.length - 1;
    };
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    slider.addEventListener('scroll', update, { passive: true });
    update();
  }
  initSliders(document);

  /* ---------- Košík ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function renderSections(names) {
    var url = (routes.root || '/') + '?sections=' + names.join(',');
    return nativeFetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function replaceFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) {
      var wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
    }
  }

  function fetchCart() {
    return nativeFetch((routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* Dárek k balíčku (doprava zdarma za 0 Kč): od X kusů deky ho přidat, pod X odebrat */
  function syncGift(cart) {
    var g = BD.gift || {};
    if (!g.variant || !cart || !cart.items) return Promise.resolve(cart);
    var mainQty = 0, giftLines = [], giftQty = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === g.variant) { giftLines.push(it); giftQty += it.quantity; }
      else if (g.product ? it.product_id === g.product : it.final_price > 0) mainQty += it.quantity;
    });
    var want = mainQty >= (g.min || 2) ? 1 : 0;
    if (giftQty === want && giftLines.length <= 1) return Promise.resolve(cart);
    var req;
    if (want && !giftLines.length) {
      req = nativeFetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: g.variant, quantity: 1, properties: { '_gift': '1' } }] })
      });
    } else {
      var updates = {};
      giftLines.forEach(function (it, i) { updates[it.key] = (i === 0 ? want : 0); });
      req = nativeFetch((routes.cartUpdate || '/cart/update') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }
    return req.then(fetchCart).catch(function () { return cart; });
  }

  function refreshCart(open) {
    var pageCart = $('[data-cart-page]');
    var cartData;
    return fetchCart().then(syncGift).then(function (cart) {
      cartData = cart;
      return $('#CartDrawer') ? renderSections(['cart-drawer']) : {};
    }).then(function (data) {
      if (data && data['cart-drawer']) { replaceFrom(data['cart-drawer'], '#CartDrawer'); emojify($('#CartDrawer')); }
      if (cartData) updateCount(cartData.item_count);
      if (pageCart) {
        // stránka košíku: překreslit celou sekci
        return nativeFetch(window.location.pathname + '?section_id=' + pageCart.closest('[id^="shopify-section"]').id.replace('shopify-section-', ''), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-cart-page]');
            if (fresh) { pageCart.innerHTML = fresh.innerHTML; emojify(pageCart); }
          });
      }
    }).then(function () {
      if (open) {
        if (BD.cartType === 'page' || !$('#CartDrawer')) { window.location.href = routes.cart || '/cart'; return; }
        openDrawer($('#CartDrawer'));
      }
    }).catch(function () { if (open) window.location.href = routes.cart || '/cart'; });
  }
  window.BDRefreshCart = refreshCart;

  function changeLine(key, qty) {
    return nativeFetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(false); });
  }

  function addItems(items) {
    return nativeFetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || BD.strings.error);
        return j;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    var removeBtn = e.target.closest('[data-line-remove]');
    var quick = e.target.closest('[data-quick-add]');
    if (qtyBtn || removeBtn) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      e.preventDefault();
      var input = $('[data-qty-value]', line);
      var q = parseInt(input.value, 10) || 0;
      var next = removeBtn ? 0 : Math.max(0, q + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
      line.style.opacity = '.5';
      changeLine(line.getAttribute('data-line-key'), next);
    } else if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      addItems([{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }])
        .then(function () { return refreshCart(false); })
        .catch(function (err) { toast(err.message); quick.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-value]');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    if (line) changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* Když do košíku přidá něco jiná aplikace (např. Kaching Bundles), otevřeme košík. */
  var appAddTimer;
  function onExternalAdd() {
    clearTimeout(appAddTimer);
    appAddTimer = setTimeout(function () { refreshCart(true); }, 150);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) onExternalAdd(); }).catch(function () {});
    }
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._bdUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (/\/cart\/add(\.js)?(\?|$)/.test(String(xhr._bdUrl || ''))) {
      xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) onExternalAdd(); });
    }
    return xhrSend.apply(this, arguments);
  };

  /* Pomocné funkce pro product.js */
  window.BDT = { $: $, $$: $$, formatMoney: formatMoney, toast: toast, refreshCart: refreshCart, addItems: addItems, emojify: emojify };

  /* Při načtení stránky srovnat dárek v košíku (např. po návratu na web) */
  (function () {
    var cc = $('[data-cart-count]');
    if (!(BD.gift && BD.gift.variant && cc && parseInt(cc.textContent, 10) > 0)) return;
    fetchCart().then(function (c) { return syncGift(c).then(function (n) { if (n !== c) refreshCart(false); }); }).catch(function () {});
  })();

  /* Editor theme: znovu inicializovat po úpravě sekce */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s && window.BDInitProduct) window.BDInitProduct(s);
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    initSliders(e.target);
    emojify(e.target);
  });
})();
